module.exports = __webpack_public_path__ + "media/B_L11.840c3ac9.mp3";